import superChat from 'ai/reducers/superChat';
import sdnApi from 'ai/services/sdn';

const { feedback } = sdnApi;

const { ACTION_TYPES } = superChat;

const superChatActions = {
    showSuperChat: (showSuperChat, prompts, data) => {
        return {
            type: ACTION_TYPES.SHOW_SUPER_CHAT,
            payload: {
                showSuperChat,
                prompts,
                entryPointData: data
            }
        };
    },
    submitFeedback: async params => {
        const { question, response, sessionId, lastMessageId } = params || {};

        return feedback({ question, response, sessionId, lastMessageId }).then(data => data);
    }
};

export default superChatActions;
